'use strict';

// pigeon wiki https://wiki.n.miui.com/pages/viewpage.action?pageId=154047549

const __RN_APP_PIPEON_SPM_INFOs__ = {};
let __RN_APP_PIPEON_SPM_INFOs_srccb = async () => { return ''};
let __RN_APP_PIPEON_SPM_INFOs_ssncb = () => { return 'Start_'+ Date.parse(new Date())};
let __RN_APP_PIPEON_SPM_INFOs_netcb = async () => { return 'unknown'};

/**
 * 未添加注释
 */
class PigeonMaker {

  constructor(spmref, scm, last_scmv2, scmv2_num) {
    this.spmref = spmref;
    this.scm = scm;
    this.last_scmv2 = last_scmv2;
    this.scmv2_num = scmv2_num;
  }

  /**
   * 设置初始环境参数
   * @params params 常量数据
   * @param params.os 操作系统：iOS、Android
   * @param params.device 设备：华为mate8、小米9等
   * @param params.uuid 设备UUID：Android imei， ios idfa等
   * @param params.did DID：移动设备下不同于uuid，pc,h5等生成的distinct_id
   * @param params.pt 平台：有品、米家、路由器、小程序、M站、PC站等
   * @param params.version 平台的版本：有品4.3.1等
   * @param params.channel 下载渠道：小米应用商店，某4s店等
   * @param params.oaid 这个是一个特殊渠道的id（头条的广告id，产品：郭薇）
   * @param params.customosversion 这个是一个特殊渠道的id（头条的广告id，产品：郭薇）
   * @param params.osversion 这个是一个特殊渠道的id（头条的广告id，产品：郭薇）
   * @param callbacks 变量数据
   * @param {Function} callbacks.sourceCallback 获取推广渠道
   * @param {Function} callbacks.sessionCallback 具体启动session
   * @param {Function} callbacks.networkCallback 当前网络状态
   */
  setEnvParamsAndCallbacks(params, callbacks) {
    __RN_APP_PIPEON_SPM_INFOs__.os = params && params.os || '';
    __RN_APP_PIPEON_SPM_INFOs__.device = params && params.device || '';
    __RN_APP_PIPEON_SPM_INFOs__.uuid = params && params.uuid || '';
    __RN_APP_PIPEON_SPM_INFOs__.did = params && params.did || '';
    __RN_APP_PIPEON_SPM_INFOs__.pt = params && params.pt || '';
    __RN_APP_PIPEON_SPM_INFOs__.version = params && params.version || '';
    __RN_APP_PIPEON_SPM_INFOs__.channel = params && params.channel || '';
    __RN_APP_PIPEON_SPM_INFOs__.oaid = params && params.oaid || '';
    __RN_APP_PIPEON_SPM_INFOs__.customosversion = params && params.customosversion || '';
    __RN_APP_PIPEON_SPM_INFOs__.osversion = params && params.osversion || '';

    if(callbacks && callbacks.sourceCallback && typeof callbacks.sourceCallback === 'function') {
      __RN_APP_PIPEON_SPM_INFOs_srccb = callbacks.sourceCallback;
    }

    if(callbacks && callbacks.sessionCallback && typeof callbacks.sessionCallback === 'function') {
      __RN_APP_PIPEON_SPM_INFOs_ssncb = callbacks.sessionCallback;
    }

    if(callbacks && callbacks.networkCallback && typeof callbacks.networkCallback === 'function') {
      __RN_APP_PIPEON_SPM_INFOs_netcb = callbacks.networkCallback;
    }
  };

  /**
   * 设置初始环境参数
   * @param os 操作系统：iOS、Android
   * @param device 设备：华为mate8、小米9等
   * @param uuid 设备UUID：Android imei， ios idfa等
   * @param did DID：移动设备下不同于uuid，pc,h5等生成的distinct_id
   * @param pt 平台：有品、米家、路由器、小程序、M站、PC站等
   * @param version 平台的版本：有品4.3.1等
   * @param channel 下载渠道：小米应用商店，某4s店等
   * @param {Function} sourceCallback 获取推广渠道
   * @param {Function} sessionCallback 具体启动session
   * @param oaid 这个是一个特殊渠道的id（头条的广告id，产品：郭薇）
   */
    setEnv(os, device, uuid, did, pt, version, channel, sourceCallback, sessionCallback, oaid) {
      __RN_APP_PIPEON_SPM_INFOs__.os = os || '';
      __RN_APP_PIPEON_SPM_INFOs__.device = device || '';
      __RN_APP_PIPEON_SPM_INFOs__.uuid = uuid || '';
      __RN_APP_PIPEON_SPM_INFOs__.did = did || '';
      __RN_APP_PIPEON_SPM_INFOs__.pt = pt || '';
      __RN_APP_PIPEON_SPM_INFOs__.version = version || '';
      __RN_APP_PIPEON_SPM_INFOs__.channel = channel || '';
      __RN_APP_PIPEON_SPM_INFOs__.oaid = oaid || '';

      if(sourceCallback && typeof sourceCallback === 'function') {
        __RN_APP_PIPEON_SPM_INFOs_srccb = sourceCallback;
      }

      if(sessionCallback && typeof sessionCallback === 'function') {
        __RN_APP_PIPEON_SPM_INFOs_ssncb = sessionCallback;
      }
    };

    /**
     * 获取pigeon对象
     * @param spm spm信息 YouPin_A.1.528.3.19748511
     * @param scm 算法标识 1000.2.3.4
     * @param iid 附带信息 key=value
     * @param fenxiao 分销字段 目前交易链路没有用到
     */

    async addCartPipeon(spm, scm, iid, fenxiao, scmv2) {
      let scmConf = {scmv2_num: this.scmv2_num, last_scmv2: this.last_scmv2};
      var SPM = {
        source : await __RN_APP_PIPEON_SPM_INFOs_srccb(),
        session : __RN_APP_PIPEON_SPM_INFOs_ssncb(), // session 具体启动session
        addcart_time : Date.parse(new Date()),
        network: await __RN_APP_PIPEON_SPM_INFOs_netcb(),
      };
      if(!__RN_APP_PIPEON_SPM_INFOs__) {
        console.log('error: 没有设置平台信息，请初始化平台信息');
        return;
      }

      var tScm = scm;
      if(!tScm || !tScm.length) {
        tScm = this.scm || '';
      }
      if(scmv2) {
        scmConf.last_scmv2 = scmv2;
        scmConf.scmv2_num = 0;
        scmConf.scmv2= scmv2;
      }
      Object.assign(SPM, __RN_APP_PIPEON_SPM_INFOs__, {spmref: this.spmref || '', spm: spm || '', scm: tScm, iid: iid || '', ...scmConf});
      var pigeon = {spm:SPM};
      if(fenxiao) {
        pigeon.fenxiao = fenxiao;
      }
      return pigeon;
    }

    /**
     * 获取pigeon字符串
     * @param pigeon
     * @param scm 算法标识 1000.2.3.4
     * @param iid 附带信息 key=value
     * @param fenxiao 分销字段 目前交易链路没有用到
     * @returns string
     */

    async addCartPipeonString(spm, scm, iid, fenxiao, scmv2) {
      var pigeon = null;
      try {
        pigeon = await this.addCartPipeon(spm, scm, iid, fenxiao, scmv2);
      } catch (error) {
        console.error('ATTENTION: pigeon is Null by error:', error);
      }
      if(pigeon && Object.keys(pigeon) && Object.keys(pigeon).length) {
        return JSON.stringify(pigeon);
      }
      return null;
    }
}
export default PigeonMaker;
